
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/navbar.js';
            vueApps['app/navbar.js'] = App0;
        

            import App1 from './app/unit.js';
            vueApps['app/unit.js'] = App1;
        

            import App2 from './app/dummy.js';
            vueApps['app/dummy.js'] = App2;
        

            import App3 from './app/search.js';
            vueApps['app/search.js'] = App3;
        

            import App4 from './app/Mithund.js';
            vueApps['app/Mithund.js'] = App4;
        

            import App5 from './app/Familie.js';
            vueApps['app/Familie.js'] = App5;
        

            import App6 from './app/AngeboteSpecials.js';
            vueApps['app/AngeboteSpecials.js'] = App6;
        

            import App7 from './app/AutumnDisrupter.js';
            vueApps['app/AutumnDisrupter.js'] = App7;
        

            import App8 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App8;
        

            import App9 from './comp/drinks.js';
            vueApps['comp/drinks.js'] = App9;
        

            import App10 from './comp/aufdieschnelle.js';
            vueApps['comp/aufdieschnelle.js'] = App10;
        

            import App11 from './comp/bildung.js';
            vueApps['comp/bildung.js'] = App11;
        

            import App12 from './comp/schietwetter.js';
            vueApps['comp/schietwetter.js'] = App12;
        

            import App13 from './app/Amyachthafen1.js';
            vueApps['app/Amyachthafen1.js'] = App13;
        

            import App14 from './app/Amyachthafen2.js';
            vueApps['app/Amyachthafen2.js'] = App14;
        

            import App15 from './app/Nordmole.js';
            vueApps['app/Nordmole.js'] = App15;
        

            import App16 from './app/BlackFriday.js';
            vueApps['app/BlackFriday.js'] = App16;
        

            import App17 from './app/UnitsAll.js';
            vueApps['app/UnitsAll.js'] = App17;
        

            import App18 from './app/Albatrosplatz1.js';
            vueApps['app/Albatrosplatz1.js'] = App18;
        

            import App19 from './app/Albatrosplatz2.js';
            vueApps['app/Albatrosplatz2.js'] = App19;
        

            import App20 from './app/Hafenpromenade1.js';
            vueApps['app/Hafenpromenade1.js'] = App20;
        

            import App21 from './app/Hafenpromenade2.js';
            vueApps['app/Hafenpromenade2.js'] = App21;
        

            import App22 from './app/Hafenpromenade3.js';
            vueApps['app/Hafenpromenade3.js'] = App22;
        

            import App23 from './app/Hafenpromenade4.js';
            vueApps['app/Hafenpromenade4.js'] = App23;
        

            import App24 from './app/Kapitaensinsel5.js';
            vueApps['app/Kapitaensinsel5.js'] = App24;
        

            import App25 from './app/Kapitaensinsel6.js';
            vueApps['app/Kapitaensinsel6.js'] = App25;
        

            import App26 from './app/Kapitaensinsel7.js';
            vueApps['app/Kapitaensinsel7.js'] = App26;
        

            import App27 from './app/Kapitaensinsel8.js';
            vueApps['app/Kapitaensinsel8.js'] = App27;
        

            import App28 from './app/Ferienlounge1.js';
            vueApps['app/Ferienlounge1.js'] = App28;
        

            import App29 from './app/Ferienlounge2.js';
            vueApps['app/Ferienlounge2.js'] = App29;
        

            import App30 from './app/Strandpromenade1.js';
            vueApps['app/Strandpromenade1.js'] = App30;
        

            import App31 from './app/FerienPark_Sternunterkunfte.js';
            vueApps['app/FerienPark_Sternunterkunfte.js'] = App31;
        

            import App32 from './app/Ferienpark_Freya.js';
            vueApps['app/Ferienpark_Freya.js'] = App32;
        

            import App33 from './app/Ferienpark_Skipper_Freya.js';
            vueApps['app/Ferienpark_Skipper_Freya.js'] = App33;
        

            import App34 from './app/Arbeitsplatz.js';
            vueApps['app/Arbeitsplatz.js'] = App34;
        

            import App35 from './app/Albatrosvillen.js';
            vueApps['app/Albatrosvillen.js'] = App35;
        

            import App36 from './app/Strandvillen.js';
            vueApps['app/Strandvillen.js'] = App36;
        

            import App37 from './app/Schleiufer1.js';
            vueApps['app/Schleiufer1.js'] = App37;
        

            import App38 from './app/Schleiufer2.js';
            vueApps['app/Schleiufer2.js'] = App38;
        

            import App39 from './app/Schleiufer3.js';
            vueApps['app/Schleiufer3.js'] = App39;
        

            import App40 from './app/Schleiufer4.js';
            vueApps['app/Schleiufer4.js'] = App40;
        

            import App41 from './app/Schleidamm1.js';
            vueApps['app/Schleidamm1.js'] = App41;
        

            import App42 from './app/Schleidamm2.js';
            vueApps['app/Schleidamm2.js'] = App42;
        

            import App43 from './app/Schleidamm3.js';
            vueApps['app/Schleidamm3.js'] = App43;
        

            import App44 from './app/Hafenpromenade5.js';
            vueApps['app/Hafenpromenade5.js'] = App44;
        

            import App45 from './app/Hafenpromenade6.js';
            vueApps['app/Hafenpromenade6.js'] = App45;
        

            import App46 from './app/Kapitaensinsel9.js';
            vueApps['app/Kapitaensinsel9.js'] = App46;
        

            import App47 from './app/Kapitaensinsel10.js';
            vueApps['app/Kapitaensinsel10.js'] = App47;
        

        
                import Comp48 from './NavbarDisrupter.vue';
                Vue.component('navbar-disrupter',Comp48);
            

                import Comp49 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp49);
            

                import Comp50 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp50);
            

                import Comp51 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp51);
            

                import Comp52 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp52);
            

                import Comp53 from './comp/DescToggle.js';
                Vue.component('voffice-toggle-text-size',Comp53);
            

                import Comp54 from './comp/gmap.js';
                Vue.component('voffice-gmap',Comp54);
            

                import Comp55 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp55);
            

                import Comp56 from './comp/carousel.vue';
                Vue.component('owl-carousel',Comp56);
            

                import Comp57 from './comp/unitofthedayhelp.vue';
                Vue.component('unitoftheday-help',Comp57);
            

                import Comp58 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp58);
            

                import Comp59 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp59);
            

                import Comp60 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp60);
            

                import Comp61 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp61);
            

                import Comp62 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp62);
            

                import Comp63 from './comp/SearchTokensConditional.vue';
                Vue.component('search-filter-tokens-conditional',Comp63);
            

                import Comp64 from './comp/ImageCarousel.vue';
                Vue.component('img-carousel',Comp64);
            

                import Comp65 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp65);
            

                import Comp66 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp66);
            

                import Comp67 from './comp/NewsletterSubscription.js';
                Vue.component('voffice-newsletter-subscription',Comp67);
            

                import Comp68 from './comp/IndexDisrupter.vue';
                Vue.component('index-disrupter',Comp68);
            

                import Comp69 from './unitoffers.vue';
                Vue.component('unit-offers',Comp69);
            

                import Comp70 from './comp/CookieBox.vue';
                Vue.component('voffice-cookie-box',Comp70);
            

                import Comp71 from './comp/contactsidebar.vue';
                Vue.component('contact-sidebar',Comp71);
            

                import Comp72 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp72);
            

                import Comp73 from './comp/gmapstatic.js';
                Vue.component('voffice-staticmap',Comp73);
            

                import Comp74 from './comp/SearchUnitByName.vue';
                Vue.component('search-unit-name',Comp74);
            

                import Comp75 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp75);
            

                import Comp76 from './comp/carousel-eigentumer.vue';
                Vue.component('owl-carousel-eigentuemer',Comp76);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    